module.exports = __webpack_public_path__ + "static/media/dashboard01.79c4ac0e.png";